<svg xmlns="http://www.w3.org/2000/svg" width="17" height="17" viewBox="0 0 17 17" fill="none">
  <path d="M1.5 14.5H15.5" stroke="#E5E5E5" stroke-width="1.3" stroke-linecap="round"/>
  <path d="M2.5 14.5V2.5H14.5V14.5" stroke="#E5E5E5" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round"/>
  <path d="M2.5 4H14.5" stroke="#E5E5E5" stroke-width="1.2" stroke-linecap="round"/>
  <circle cx="2.5" cy="6" r="1.2" fill="#E5E5E5"/>
  <circle cx="14.5" cy="6" r="1.2" fill="#E5E5E5"/>
  <path d="M2.5 6L6.5 9.5" stroke="#E5E5E5" stroke-width="1.1" stroke-linecap="round"/>
  <path d="M14.5 6L10.5 9.5" stroke="#E5E5E5" stroke-width="1.1" stroke-linecap="round"/>
  <rect x="1" y="7" width="1.5" height="5" rx="0.3" fill="#E5E5E5"/>
  <rect x="14.5" y="7" width="1.5" height="5" rx="0.3" fill="#E5E5E5"/>
</svg>
